import { StyleSheet } from 'react-native';

export const statBarStyles = StyleSheet.create({
  container: { gap: 5 },
  valuesRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  value: {
    fontSize: 17,
    fontWeight: '800',
    minWidth: 32,
    textAlign: 'center',
  },
  label: {
    fontSize: 9,
    fontWeight: '700',
    letterSpacing: 2,
    color: '#6B7280',
    textTransform: 'uppercase',
    flex: 1,
    textAlign: 'center',
  },
  track: {
    height: 4,
    borderRadius: 9999,
    backgroundColor: 'rgba(255,255,255,0.06)',
    overflow: 'hidden',
    flexDirection: 'row',
  },
  trackDivider: {
    width: 2,
    backgroundColor: '#0A0612',
  },
});
